export enum CurrentStepNames {
  sellGoldLanding = 'SELL_GOLD_LANDING',
  sellGoldCheckout = 'SELL_GOLD_CHECKOUT',
  PaymentStatus = 'PAYMENT_STATUS',
}

export enum SipStepName {
  sipLanding = 'SIP_LANDING_PAGE',
  sipCheckout = 'SIP_CHECKOUT',
  sipStatus = 'SIP_PAYMENT_STATUS',
}

export enum BuyStepName {
  buyLanding = 'BUY_LANDING_PAGE',
  buyCheckout = 'BUY_CHECKOUT',
  buyStatus = 'BUY_PAYMENT_STATUS',
}

export enum GiftStepName {
  giftCheckout = 'GIFT_CHECKOUT',
  giftStatus = 'GIFT_PAYMENT_STATUS',
}
